module.exports = __webpack_public_path__ + "static/media/Animation_middle.102417ba.mp4";